import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "font-awesome/css/font-awesome.min.css";
import { Modal, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const QRCodeComponent = ({
  iconColor,
  title,
  config,
  group,
  isModalOpen,
  handleQRClick,
}) => {
  const jsonData = {
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_COMPONENT_NAME":
      "com.leadschool.hmdm/com.leadschool.hmdm.AdminReceiver",
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_DOWNLOAD_LOCATION": `${process.env.REACT_APP_TPS_PACKAGE}`,
    "android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_CHECKSUM": `${process.env.REACT_APP_TPS_CHECKSUM}`,
    "android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED": true,
    "android.app.extra.PROVISIONING_SKIP_ENCRYPTION": true,
    "android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE": {
      "com.hmdm.CONFIG": `${config}`,
      "com.hmdm.GROUP": `1,${group}`,
      "com.hmdm.BASE_URL": `${process.env.REACT_APP_MDM_URL}`,
      "com.hmdm.SERVER_PROJECT": "",
    },
  };

  return (
    <div>
      <FontAwesomeIcon icon={"qrcode"} color={iconColor ?? "black"} size="2x" />
      <Modal
        open={isModalOpen}
        title={
          <Row
            className="hardware-info-row"
            style={{ justifyContent: "start" }}
          >
            <span className="summary-value">{title}</span>
          </Row>
        }
        onCancel={() => {
          handleQRClick();
        }}
        footer={[]}
      >
        <div className="qr-body-center">
          <QRCodeCanvas
            value={JSON.stringify(jsonData)}
            className="qr-content"
            size={360}
          />
        </div>
      </Modal>
    </div>
  );
};

export default QRCodeComponent;
